<template>
  <div class="invoice-pagination">
    <button
      :class="[
        'invoice-pagination__page-nav-btn',
        currentPage === 1 && 'invoice-pagination__page-nav-btn--disabled',
      ]"
      @click="setCurrentPage(currentPage - 1)"
      v-html="'<'"
    ></button>
    <button
      v-for="page in Object.keys(pages)"
      :key="page"
      :class="[
        'invoice-pagination__page-no-btn',
        parseInt(page) === currentPage &&
          'invoice-pagination__page-no-btn--selected',
      ]"
      @click="setCurrentPage(parseInt(page))"
    >
      {{ page }}
    </button>
    <button
      :class="[
        'invoice-pagination__page-nav-btn',

        currentPage === totalPages &&
          'invoice-pagination__page-nav-btn--disabled',
      ]"
      @click="setCurrentPage(currentPage + 1)"
      v-html="'>'"
    ></button>
  </div>
</template>

<script>
export default {
  name: 'InvoicePagination',
  props: {
    currentPage: {
      type: Number,
      required: true,
    },
    pages: {
      type: Object,
      required: true,
    },
    totalPages: {
      type: Number,
      required: true,
    },
  },
  methods: {
    setCurrentPage(pageNum) {
      this.$emit('update-current-page-number', pageNum)
    },
  },
}
</script>

<style lang="scss">
.invoice-pagination {
  margin: 10px 0 0 0;
  display: flex;
  justify-content: flex-end;
  &__page-no-btn,
  &__page-nav-btn {
    border: none;
    background: transparent;
    color: var(--white);
    cursor: pointer;
    font-family: var(--font-bold);
    &--disabled {
      opacity: 0.5;
      pointer-events: none;
    }
  }
  &__page-no-btn {
    margin: 0 5px;
    padding: 5px 10px;
    border-radius: 100%;
    color: var(--bright-gray);
    &--selected {
      color: var(--white);
      background: var(--dark-gray);
    }
  }
}
</style>
